import { render, staticRenderFns } from "./InfoBottom.vue?vue&type=template&id=4aa694ac&scoped=true&lang=pug&"
import script from "./InfoBottom.vue?vue&type=script&lang=ts&"
export * from "./InfoBottom.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBottom.vue?vue&type=style&index=0&id=4aa694ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa694ac",
  null
  
)

export default component.exports